import React from 'react'
import { FormHeader } from './FormHeader'

/**
 * Demo component showcasing the new FormHeader API with showElements
 */
export const FormHeaderDemo: React.FC = () => {
  const demoContent = {
    icon: 'user',
    caption: 'Welcome to your account',
    title: 'Account Dashboard',
  }

  return (
    <div
      className="form-header-demo"
      style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto' }}>
      <h2>FormHeader Component Demo</h2>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Default Variant (Backward Compatible)</h3>
        <FormHeader
          title="Welcome"
          caption="Please sign in to continue"
          icon="user"
        />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Stacked Variant - All Elements</h3>
        <FormHeader
          variant="stacked"
          content={demoContent}
          showElements={['icon', 'caption', 'title']}
        />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Stacked Variant - Icon + Title Only</h3>
        <FormHeader
          variant="stacked"
          content={demoContent}
          showElements={['icon', 'title']}
        />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Stacked Variant - Title Only (Default)</h3>
        <FormHeader
          variant="stacked"
          content={demoContent}
        />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Stacked Variant - Icon Only</h3>
        <FormHeader
          variant="stacked"
          content={demoContent}
          showElements={['icon']}
        />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Stacked Variant - Caption + Title</h3>
        <FormHeader
          variant="stacked"
          content={demoContent}
          showElements={['caption', 'title']}
        />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Stacked Variant - Empty showElements (Renders empty div)</h3>
        <FormHeader
          variant="stacked"
          content={demoContent}
          showElements={[]}
        />
        <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>This renders an empty div with just the form-header classes</p>
      </div>
    </div>
  )
}
